import React, { useMemo } from 'react';
import { mobileUiOchags } from '../../../utils/mobileCalculations';

const OchagCardsSection = ({
  form5Data = null,
  handbooks = [],
  independentForm2Data = null,
  form1Data = null,
  dataType = 'to',
  calculateTotalsByNasazhdeniya = null,
  calculateDamagePercentage_func = null,
  formData = null,
  onOchagClick = null,
  selectedOchags = new Set(),
  isDisabled = false,
  showOnlySelected = false,
  calculateForm5TotalDamage = null,
  getOchagDamageValueForCause = null
}) => {

  const causesWithOchag = useMemo(() =>
    mobileUiOchags(5, form5Data, handbooks, independentForm2Data, form1Data, dataType),
    [form5Data, handbooks, independentForm2Data, form1Data, dataType]
  );
  const totalStandDamagePercentage = causesWithOchag[0]?.damagePercentage || 0;

  // Используем переданные selectedOchags или получаем из formData
  const currentSelectedOchags = useMemo(() => {
    if (selectedOchags && selectedOchags.size !== undefined) {
      return selectedOchags;
    }
    if (formData?.selectedOchags === undefined) {
      return new Set();
    }
    return new Set(formData.selectedOchags || []);
  }, [formData, formData?.selectedOchags, selectedOchags]);

  // Получаем данные очагов из formData.ochagData
  const ochagData = useMemo(() => {
    if (!formData || !formData.ochagData) {
      return {};
    }
    return formData.ochagData;
  }, [formData?.ochagData]);

  // Фильтруем очаги по выбранным
  const filteredCausesWithOchag = useMemo(() => {
    // Если showOnlySelected = true (используется в Form6), показываем только выбранные очаги
    if (showOnlySelected) {
      return causesWithOchag.filter(cause => {
        const causeKey = String(cause.id);
        return currentSelectedOchags.has(causeKey) || 
          Array.from(currentSelectedOchags).some(key => key === causeKey || key.startsWith(`${cause.id}-`));
      });
    }
    // Иначе показываем все очаги (для Form5)
    return causesWithOchag;
  }, [causesWithOchag, currentSelectedOchags, showOnlySelected]);

  if (filteredCausesWithOchag.length === 0) {
    return null;
  }

  return (
    <div style={{ 
      marginTop: '20px', 
      padding: '20px',
      backgroundColor: '#f8f9fa',
      borderRadius: '8px',
      border: '1px solid #dee2e6'
    }}>
      <h3 style={{ 
        margin: '0 0 20px 0', 
        fontSize: '16px', 
        fontWeight: '600',
        color: '#212529'
      }}>
        Очаги
      </h3>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
        gap: '15px'
      }}>
        {filteredCausesWithOchag.map((cause, index) => {
          // Используем ID причины как уникальный ключ очага (без яруса)
          const causeKey = String(cause.id);
          
          // Находим данные очага по ключу (ID причины)
          const currentOchagData = formData?.ochagData || {};
          let ochagInfo = currentOchagData[causeKey] || {};
          
          // Если не нашли по ключу с ID, пробуем найти по коду причины
          if (Object.keys(ochagInfo).length === 0) {
            const causeCode = cause.code ? String(cause.code) : null;
            if (causeCode) {
              ochagInfo = currentOchagData[causeCode] || {};
            }
          }
          
          // Если все еще не нашли, пробуем найти по ключу с ID (для обратной совместимости)
          if (Object.keys(ochagInfo).length === 0) {
            const ochagDataKey = Array.from(Object.keys(currentOchagData)).find(key => key.startsWith(`${cause.id}-`));
            if (ochagDataKey) {
              ochagInfo = currentOchagData[ochagDataKey] || {};
            }
          }

          const isSelected = currentSelectedOchags.has(causeKey) || 
            Array.from(currentSelectedOchags).some(key => key === causeKey || key.startsWith(`${cause.id}-`));
          const isDisabledForThis = !isSelected && isDisabled;

          return (
            <div
              key={causeKey}
              onClick={(e) => {
                // Открываем модальное окно если клик не на чекбокс
                if (e.target.type !== 'checkbox' && e.target.tagName !== 'INPUT' && onOchagClick) {
                  // Если очаг не выбран, автоматически выбираем его (если не превышен лимит)
                  if (!isSelected && !isDisabledForThis) {
                    onOchagClick(causeKey, true);
                  } else if (isSelected) {
                    onOchagClick(causeKey, false);
                  }
                }
              }}
              style={{
                backgroundColor: 'white',
                padding: '15px',
                borderRadius: '6px',
                border: '1px solid #dee2e6',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                position: 'relative',
                opacity: isDisabledForThis ? 0.6 : 1,
                cursor: 'pointer'
              }}
            >
              <input
                type="checkbox"
                checked={isSelected}
                disabled={isDisabledForThis}
                onChange={(e) => {
                  e.stopPropagation();
                  if (onOchagClick) {
                    onOchagClick(causeKey, e.target.checked);
                  }
                }}
                onClick={(e) => e.stopPropagation()}
                style={{
                  position: 'absolute',
                  top: '10px',
                  left: '10px',
                  width: '18px',
                  height: '18px',
                  cursor: isDisabledForThis ? 'not-allowed' : 'pointer',
                  zIndex: 10,
                  accentColor: '#6c757d'
                }}
              />
              <div style={{ 
                marginBottom: '10px',
                paddingLeft: '30px'
              }}>
                <strong style={{ 
                  fontSize: '14px', 
                  color: '#212529',
                  display: 'block',
                  marginBottom: '10px'
                }}>
                  {cause.code ? `${cause.name} (${cause.code})` : cause.name}
                </strong>
                <div style={{ 
                  fontSize: '13px', 
                  color: '#495057',
                  fontWeight: '500',
                  marginBottom: '5px'
                }}>
                  Степень: <span style={{ 
                    fontWeight: '600'
                  }}>
                    {cause.state}
                  </span>
                </div>
                {/* Для формы №5 везде показываем итог по насаждению */}
                {(calculateForm5TotalDamage || totalStandDamagePercentage !== undefined) && (
                  <div style={{ 
                    fontSize: '13px', 
                    color: '#495057',
                    fontWeight: '500',
                    marginBottom: '5px'
                  }}>
                    Повреждение крон: <span style={{ 
                      fontWeight: '600'
                    }}>
                      {totalStandDamagePercentage.toFixed(2)}%
                    </span>
                  </div>
                )}
                {/* Отображаем данные очага: ВО, фаза и тип (как в Form4) */}
                {(ochagInfo.vo || ochagInfo.phase || ochagInfo.type) && (
                  <div style={{ 
                    fontSize: '12px', 
                    color: '#6c757d',
                    marginTop: '8px',
                    paddingTop: '8px',
                    borderTop: '1px solid #e9ecef'
                  }}>
                    {ochagInfo.vo && (
                      <div style={{ marginBottom: '4px' }}>
                        ВО: {(() => {
                          const voHandbook = handbooks.find(h => h.id === 40);
                          if (voHandbook && voHandbook.references) {
                            const vo = voHandbook.references.find(
                              r => r.id.toString() === String(ochagInfo.vo)
                            );
                            return vo ? vo.name : ochagInfo.vo;
                          }
                          return ochagInfo.vo;
                        })()}
                      </div>
                    )}
                    {ochagInfo.phase && (
                      <div style={{ marginBottom: '4px' }}>
                        Фаза: {(() => {
                          const phaseMap = {
                            'INITIAL': 'Начальная',
                            'POPULATION_GROWTH': 'Нарастания численности',
                            'OUTBREAK': 'Собственно вспышка',
                            'CRISIS': 'Кризис',
                            'EMERGING': 'Возникающий',
                            'ACTIVE': 'Действующий',
                            'FADING': 'Затухающий'
                          };
                          if (ochagInfo.phase === 'arising') return 'Возникающая';
                          if (ochagInfo.phase === 'acting') return 'Действующая';
                          return phaseMap[ochagInfo.phase] || ochagInfo.phase;
                        })()}
                      </div>
                    )}
                    {ochagInfo.type && (
                      <div style={{ marginBottom: '4px' }}>
                        Тип: {ochagInfo.type === 'episodic' || ochagInfo.type === 'EPISODIC' ? 'Эпизодический' : 
                              ochagInfo.type === 'chronic' || ochagInfo.type === 'CHRONIC' ? 'Хронический' : 
                              ochagInfo.type}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OchagCardsSection;
